// AnimatedText.js
import React from "react";
import '../styles/Textanimation.css';
import { useInView } from "react-intersection-observer";

// import styles from "../../styles/AnimatedText.module.css";
const AnimatedText4 = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // animate only once when it first comes into view
    threshold: 0.1,    // trigger when 10% of the component is in view
  });
  return (
    <div ref={ref} className={`container ${inView ? "animate" : ""}`}>
      <div className="text a"> We </div>
      <div className="text b"> guarantee </div>
      <div className="text c"> you'll  </div>
      <div className="text d"> never </div>
      <div className="text e"> go </div>
      <div className="text f"> back </div>
    </div>
  );
};
export default AnimatedText4;